import { Injectable } from '@angular/core';

import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { Observable, of } from 'rxjs';

import { CurrencyPipe } from '../../../base/pipes/currency.pipe';
import { IOverAskMessages, OverAskBetslipError } from '../../../model/over-ask/over-ask';
import { BetslipError } from '../../validation/errors/betslip-error';
import { OverAskError } from '../../validation/errors/over-ask/over-ask.error';
import { IExtendedMessage, MessageFormatter } from '../../validation/services/formatting/message-formatters/message-formatter';
import { OverAskMessagesProvider } from './over-ask-messages.provider';

@Injectable()
export class OverAskMessageFormatter extends MessageFormatter<OverAskError> {
    constructor(
        private overAskMessageProvider: OverAskMessagesProvider,
        private interpolatePipe: StringInterpolationPipe,
        private currencyPipe: CurrencyPipe,
    ) {
        super();
    }

    format(error: OverAskError): Observable<IExtendedMessage | string> {
        let message: string = this.overAskMessageProvider.messages[error.code as keyof IOverAskMessages] || error.code;
        let title: string | undefined;

        if (error.code === OverAskBetslipError.OfferExpired || error.code === OverAskBetslipError.OfferRejected) {
            const newStakeHint = error.newStakeHint || 0;

            if (newStakeHint > 0) {
                message = this.interpolatePipe.transform(message, { newStakeHintWithCurrency: this.currencyPipe.transform(newStakeHint, true) });
                if (error.code === OverAskBetslipError.OfferExpired) {
                    title = this.overAskMessageProvider.messages[`${error.code}Title`];
                }
            } else {
                message = this.overAskMessageProvider.messages.ErrorOfferZeroStakeHint;
            }
        }

        if (error.code === OverAskBetslipError.MaximumWinOfBetExceeded) {
            message = this.overAskMessageProvider.messages.ErrorMaximumWinOfBetExceeded;
        }

        return of(title ? { message, title } : message);
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof OverAskError;
    }
}
